import { useCallback, useEffect, useState } from "react";
import { getUnreadMessagesCount } from "../Services/apiService";

const readStoredCount = () => {
  const stored = localStorage.getItem("MsgCountData");
  return stored != null && stored !== "" ? Number(stored) : 0;
};

export const useMessageCount = () => {
  const [msgCount, setMsgCount] = useState(readStoredCount);

  const MessagesCount = useCallback(async ({ forceRefresh = false } = {}) => {
    try {
      const count = await getUnreadMessagesCount({ forceRefresh });
      if (count != null) {
        setMsgCount(Number(count) || 0);
      }
    } catch (e) {
      // preserve previous count on error
    }
  }, []);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (!sessionId) return undefined;

    MessagesCount({ forceRefresh: true });

    const handleUserLoggedIn = () => {
      MessagesCount({ forceRefresh: true });
    };

    const handleCountUpdated = (event) => {
      const count = event?.detail?.count;
      if (count != null) {
        setMsgCount(Number(count) || 0);
      }
    };

    window.addEventListener("userLoggedIn", handleUserLoggedIn);
    window.addEventListener("messageCountUpdated", handleCountUpdated);

    return () => {
      window.removeEventListener("userLoggedIn", handleUserLoggedIn);
      window.removeEventListener("messageCountUpdated", handleCountUpdated);
    };
  }, [MessagesCount]);

  return { msgCount, setMsgCount, MessagesCount };
};
